import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/fbpixel';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Failures } from './components/Failures';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-bio-black selection:bg-bio-teal selection:text-bio-black overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Failures data-id="element-3" />
      <Mechanism data-id="element-4" />
      <Deliverables data-id="element-5" />
      <Audience data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Proof data-id="element-8" />
      <FAQ data-id="element-9" />
      <Offer data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}